import { UserActions } from 'actions/actionTypes';

interface IAgenticWidgetUsageState {
  /** Pauses (-1) and resumes (+1) since `features_and_limits` last loaded. */
  usedDelta: number;
}

const initialState: IAgenticWidgetUsageState = { usedDelta: 0 };

// Kept out of `state.user` on purpose: many components subscribe to the whole
// user object, so writing a pause into it re-rendered the entire page.
const agenticWidgetUsage = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: { type: string; delta?: number }
): IAgenticWidgetUsageState => {
  switch (action.type) {
    case UserActions.ADJUST_AGENTIC_WIDGET_USAGE:
      return { usedDelta: state.usedDelta + (action.delta ?? 0) };
    // The fetched count already includes every earlier pause and resume.
    case UserActions.FETCH_USER_SUBSCRIPTION_LIMITS_SUCCESS:
      return state.usedDelta === 0 ? state : initialState;
    default:
      return state;
  }
};

export default agenticWidgetUsage;
